import classNames from 'classnames';

type Props = {
  actions?: React.ReactNode;
  children?: React.ReactNode;
  id?: string;
  title?: string;
  subtitle?: string;
  className?: string;
  isCompact?: boolean;
};

const KpcCard: React.FC<Props> = ({
  actions,
  children,
  id,
  title,
  subtitle,
  className,
  isCompact = false,
}) => (
  <div
    id={id}
    className={classNames('rounded-2xl', isCompact ? 'bg-gray-100 p-0' : 'bg-white p-4', className)}
  >
    {(!!title || !!actions) && (
      <div
        className={classNames('flex items-center', isCompact ? 'pb-0' : 'pb-4', {
          'justify-between': !!title,
          'justify-end': !title,
        })}
      >
        {!!title && <h4>{title}</h4>}
        {actions}
      </div>
    )}
    {!!subtitle && <p className="pb-4 text-xs italic">{subtitle}</p>}
    {children}
  </div>
);

export default KpcCard;
